(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(85);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _urls = __webpack_require__(94);
	
	var _urls2 = _interopRequireDefault(_urls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('searchEngineFrontend.searchInterface.shared.constants', []).constant('urls', _urls2.default);
	module.exports = exports['default'];

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports) {

	module.exports = "<rc-app-template app-title=\"UP Search\" page-title=\"\" nav-content=app.navContent logout=false> <div class=row> <div class=\"medium-8 large-6 medium-centered column\"> <rc-alerts alerts=app.alerts ng-show=!!app.alerts.length></rc-alerts> </div> </div> <ui-view></ui-view> </rc-app-template>";

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = "<search-bar search-term=$ctrl.searchTerm on-search=$ctrl.onSearch($event) spellcheck=$ctrl.spellcheck></search-bar> <web-results on-load-more-results=$ctrl.onLoadMoreResults() results=$ctrl.webResults loading=$ctrl.webResults.loading search-term=$ctrl.searchTerm search-term-to-search=$ctrl.searchTermToSearch infinite-scroll-disabled=$ctrl.infiniteScrollDisabled></web-results> <feedback-modal is-open=$ctrl.feedbackModal.open on-cancel=$ctrl.closeModal() on-complete=$ctrl.modalActionComplete($event)></feedback-modal> ";

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = "<rc-modal class=feedback-modal toggle=$ctrl.isOpen heading=Feedback include-cancel=true on-close=$ctrl.closeModal()> <form name=$ctrl.feedbackform ng-submit=$ctrl.submitFeedback()> <div class=row> <div class=\"large-4 columns\"> <label>Name:</label> </div> <div class=\"large-8 columns\"> <input required type=text ng-model=$ctrl.feedback.name /> </div> </div> <div class=row> <div class=\"large-4 columns\"> <label>Email:</label> </div> <div class=\"large-8 columns\"> <input required type=text rc-validate-email ng-model=$ctrl.feedback.email /> </div> </div> <div class=row> <div class=\"large-4 columns\"> <label>Did you find what you were looking for?</label> </div> <div class=\"large-8 columns\"> <select required ng-model=$ctrl.feedback.success> <option value=\"Yes, I found what I was looking for.\">Yes, I found what I was looking for.</option> <option value=\"Yes, but it was not one of the first results.\">Yes, but it was not one of the first results.</option> <option value=\"Yes, but I had to try several times to find it.\">Yes, but I had to try several times to find it.</option> <option value=\"No, I did not find what I was looking for.\">No, I did not find what I was looking for.</option> </select> </div> </div> <div class=row> <div class=\"text-center columns\"> <button type=submit>Submit</button> </div> </div> </form> </rc-modal>";

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = "<form ng-submit=\"$ctrl.search($ctrl.searchTerm, false)\"> <div class=row> <div class=\"search-wrapper columns large-8\"> <div class=\"columns large-6 medium-6\"> <rc-autocomplete rc-input-model=$ctrl.searchTerm list-expression=\"searchTerm for searchTerm in $ctrl.suggestions | filter:$viewValue | limitTo:5\" on-select=\"$ctrl.search($ctrl.searchTerm, false)\"> </rc-autocomplete> </div> <div class=\"columns large-3 medium-3\"> <button type=submit>Search</button> </div> <div class=\"columns large-3 medium-3\"> <rc-overlay> <rc-overlay-target> <button type=button class=dropdown-button>Sources</button> </rc-overlay-target> <rc-overlay-content> <ul rc-listview input-group> <li ng-repeat=\"source in ::$ctrl.sources\"> <rc-checkbox> <input id=\"{{ ::source.label}}\" name=\"{{ ::source.label}}\" type=checkbox ng-change=$ctrl.filterChange() ng-model=$ctrl.checkbox.sources[source.filter] /> </rc-checkbox> <label for=\"{{ ::source.label}}\" ng-bind=::source.label></label> </li> </ul> </rc-overlay-content> </rc-overlay> </div> </div> </div> <div class=spellcheck ng-if=\"$ctrl.spellcheck.correctionTerm && $ctrl.spellcheck.correctionTerm != $ctrl.lastSearchTerm\"> <div ng-if=$ctrl.ignoreSpellcheck> <p><b>Did you mean: <a ng-click=\"$ctrl.search($ctrl.spellcheck.correctionTerm, false)\">{{$ctrl.spellcheck.correctionTerm}}</a></b></p> </div> <div ng-if=!$ctrl.ignoreSpellcheck> <p> <b> <span>Showing results for </span> <a ng-click=\"$ctrl.search($ctrl.spellcheck.correctionTerm, false)\">{{$ctrl.spellcheck.correctionTerm}}</a> </b> <br> <span>Search instead for </span> <a ng-click=\"$ctrl.search($ctrl.searchTerm, true)\">{{$ctrl.searchTerm}}</a> </p> </div> </div> </form>";

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"columns large-9 small-12\"> <div ng-if=$ctrl.results.showResults> <p ng-if=\"$ctrl.results.records.size === 0\">No Results Found. If this is unexpected, please submit feedback.</p> <p ng-if=\"$ctrl.results.records.size != 0\">Found {{$ctrl.results.totalRecordsFound}} results</p> </div> <div class=results-container infinite-scroll=$ctrl.loadMoreResults() infinite-scroll-distance=0 infinite-scroll-disabled=$ctrl.infiniteScrollDisabled> <div class=result-container ng-repeat=\"i in $ctrl.results.records track by $index\"> <a ng-mousedown=\"$ctrl.postActivityStatistic(i.url, $index)\" href={{i.reference}}> <h4 class=title ng-bind-html=\"i.title | words: 10 | trustAsHtml\"></h4> </a> <div class=icon-container ng-if=i.icon> <span class=icon ng-class=i.icon></span> </div> <p class=reference>{{i.reference}}</p> <p class=summary ng-bind-html=\"i.summary | removeTags | highlightWords: $ctrl.searchTerm | words: 50 | trustAsHtml\"></p> </div> <div ng-show=$ctrl.loading> <div style=min-height:100px rc-loading=$ctrl.loading inline message=\"Loading results...\"></div> </div> </div> </div>";

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(72);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(65);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  bindings: {},
	  controller: _app2.default,
	  controllerAs: 'app',
	  template: _app4.default
	};
	module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	stateConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$compileProvider', '$logProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stateConfig;
	function stateConfig($stateProvider, $urlRouterProvider, $compileProvider, $logProvider, $locationProvider) {
	  'ngInject';
	
	  $stateProvider.state('searchEngineFrontend', {
	    abstract: true,
	    template: '<ui-view></ui-view>'
	  });
	
	  $urlRouterProvider.otherwise('/');
	  $locationProvider.html5Mode({
	    enabled: true,
	    requireBase: false
	  });
	
	  // go/generator-webpack-globals
	  if (true) {
	    $compileProvider.debugInfoEnabled(false);
	    $logProvider.debugEnabled(false);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppController = function AppController($rcAlerts, NAV_CONTENT) {
	  'ngInject';
	
	  _classCallCheck(this, AppController);
	
	  this.alerts = $rcAlerts.alerts;
	
	  this.navContent = NAV_CONTENT;
	};
	AppController.$inject = ['$rcAlerts', 'NAV_CONTENT'];
	
	exports.default = AppController;
	module.exports = exports['default'];

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angularUiRouter = __webpack_require__(17);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _ricola = __webpack_require__(7);
	
	var _ricola2 = _interopRequireDefault(_ricola);
	
	var _shared = __webpack_require__(83);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _app = __webpack_require__(71);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(70);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('searchEngineFrontend.app', [_ricola2.default, _angularUiRouter2.default, _shared2.default.name]).config(_app2.default).component('app', _app4.default);
	module.exports = exports['default'];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navContent = __webpack_require__(75);
	
	var _service = __webpack_require__(76);
	
	var _service2 = _interopRequireDefault(_service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('searchEngineFrontend.app.shared.constants', []).constant('NAV_CONTENT', _navContent.NAV_CONTENT).constant('SERVICE', new _service2.default('/AUT/search-engine-frontend/secure/jas'));
	module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAV_CONTENT = exports.NAV_CONTENT = [{
	  label: 'Search',
	  url: '/uws/ui/index.html'
	}];

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Service = function () {
	  function Service(base) {
	    _classCallCheck(this, Service);
	
	    this.base = base;
	
	    return {
	      BASE: this.base,
	      PREFIX: this.prefix
	    };
	  }
	
	  _createClass(Service, [{
	    key: 'prefix',
	    get: function get() {
	      return this.base.replace(/\/$/, '');
	    }
	  }]);
	
	  return Service;
	}();
	
	exports.default = Service;
	module.exports = exports['default'];

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.HighlightMatchingWords = HighlightMatchingWords;
	// Source:  
	function HighlightMatchingWords() {
	    'ngInject';
	
	    return function (input, searchTerm) {
	        var searchTerms = searchTerm.replace(/ +/g, " ").split(" ");
	        for (var i = 0; i < searchTerms.length; i++) {
	            input = input.replace(new RegExp(searchTerms[i], 'gi'), '<strong>$&</strong>');
	        }
	        return input;
	    };
	}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	exports.PhonenumberFilter = PhonenumberFilter;
	// Source: http://stackoverflow.com/questions/12700145/format-telephone-and-credit-card-numbers-in-angularjs
	function PhonenumberFilter() {
	        'ngInject';
	
	        return function (tel) {
	                if (!tel) {
	                        return '';
	                }
	
	                var value = tel.toString().trim().replace(/^\+/, '');
	
	                if (value.match(/[^0-9]/)) {
	                        return tel;
	                }
	
	                var country, city, number;
	
	                switch (value.length) {
	                        case 10:
	                                // +1PPP####### -> C (PPP) ###-####
	                                country = 1;
	                                city = value.slice(0, 3);
	                                number = value.slice(3);
	                                break;
	
	                        case 11:
	                                // +CPPP####### -> CCC (PP) ###-####
	                                country = value[0];
	                                city = value.slice(1, 4);
	                                number = value.slice(4);
	                                break;
	
	                        case 12:
	                                // +CCCPP####### -> CCC (PP) ###-####
	                                country = value.slice(0, 3);
	                                city = value.slice(3, 5);
	                                number = value.slice(5);
	                                break;
	
	                        default:
	                                return tel;
	                }
	
	                if (country == 1) {
	                        country = "";
	                }
	
	                number = number.slice(0, 3) + '-' + number.slice(3);
	
	                return (country + " (" + city + ") " + number).trim();
	        };
	}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RemoveTags = RemoveTags;
	// Source:  http://stackoverflow.com/questions/36366319/angular-strip-all-tags-from-inputs
	function RemoveTags() {
	    'ngInject';
	
	    return function (input) {
	        return input.replace(/<[^>]+>/g, '');
	    };
	}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	'use strict';
	
	TrustAsHtml.$inject = ['$sce'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TrustAsHtml = TrustAsHtml;
	function TrustAsHtml($sce) {
	    'ngInject';
	
	    return function (input) {
	        return $sce.trustAsHtml(input);
	    };
	}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WordFilter = WordFilter;
	// Source:  https://github.com/sparkalow/angular-truncate/blob/master/src/truncate.js
	function WordFilter() {
	    'ngInject';
	
	    return function (input, words) {
	        if (isNaN(words)) {
	            return input;
	        }
	        if (words <= 0) {
	            return '';
	        }
	        if (input) {
	            var inputWords = input.split(/\s+/);
	            if (inputWords.length > words) {
	                input = inputWords.slice(0, words).join(' ') + '…';
	            }
	        }
	        return input;
	    };
	}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PhonenumberFilter = __webpack_require__(78);
	
	var _WordFilter = __webpack_require__(81);
	
	var _TrustAsHtml = __webpack_require__(80);
	
	var _RemoveTags = __webpack_require__(79);
	
	var _HighlightMatchingWords = __webpack_require__(77);
	
	exports.default = angular.module('searchEngineFrontend.app.shared.filters', []).filter('phonenumber', _PhonenumberFilter.PhonenumberFilter).filter('words', _WordFilter.WordFilter).filter('trustAsHtml', _TrustAsHtml.TrustAsHtml).filter('removeTags', _RemoveTags.RemoveTags).filter('highlightWords', _HighlightMatchingWords.HighlightMatchingWords);
	module.exports = exports['default'];

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(74);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _services = __webpack_require__(84);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _filters = __webpack_require__(82);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('searchEngineFrontend.app.shared', [_constants2.default.name, _services2.default.name, _filters2.default.name]); /*
	                                                                                                                                                   * Want to add more shared files? go/generator-shared
	                                                                                                                                                   */
	
	module.exports = exports['default'];

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * Want to add a service? go/generator-shared-service
	 */
	
	exports.default = angular.module('searchEngineFrontend.app.shared.services', []);
	module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(10);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _ricola = __webpack_require__(7);
	
	var _ricola2 = _interopRequireDefault(_ricola);
	
	var _angularResource = __webpack_require__(23);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularUiRouter = __webpack_require__(17);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _app = __webpack_require__(73);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _searchInterface = __webpack_require__(86);
	
	var _searchInterface2 = _interopRequireDefault(_searchInterface);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var app = _angular2.default.module('searchEngineFrontend', [_ricola2.default, _angularResource2.default, _angularUiRouter2.default, _app2.default.name, _searchInterface2.default.name]);
	
	_angular2.default.element(document).ready(function () {
	  (0, _angular.bootstrap)(document.documentElement, [app.name], {
	    strictDi: !("mock" in _angular2.default)
	  });
	});
	
	exports.default = app.name;
	module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ricola = __webpack_require__(7);
	
	var _ricola2 = _interopRequireDefault(_ricola);
	
	var _angularUiRouter = __webpack_require__(17);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _searchInterface = __webpack_require__(88);
	
	var _searchInterface2 = _interopRequireDefault(_searchInterface);
	
	var _searchInterface3 = __webpack_require__(87);
	
	var _searchInterface4 = _interopRequireDefault(_searchInterface3);
	
	var _shared = __webpack_require__(95);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('searchEngineFrontend.searchInterface', [_ricola2.default, _angularUiRouter2.default, _shared2.default.name]).config(_searchInterface2.default).component('searchInterface', _searchInterface4.default);
	module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _searchInterface = __webpack_require__(89);
	
	var _searchInterface2 = _interopRequireDefault(_searchInterface);
	
	var _searchInterface3 = __webpack_require__(66);
	
	var _searchInterface4 = _interopRequireDefault(_searchInterface3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  bindings: {},
	  controller: _searchInterface2.default,
	  //controllerAs: 'searchInterface',
	  template: _searchInterface4.default
	};
	module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	'use strict';
	
	searchInterfaceConfig.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = searchInterfaceConfig;
	function searchInterfaceConfig($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('searchEngineFrontend.searchInterface', {
	    url: '/index.html?q&f',
	    template: '<search-interface></search-interface>',
	    reloadOnSearch: false
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SearchInterfaceController = function () {
	  SearchInterfaceController.$inject = ['SearchService', 'StatsService', '$scope', '$stateParams', '$location', '$rcAlerts', '$q', '$log', '$http'];
	  function SearchInterfaceController(SearchService, StatsService, $scope, $stateParams, $location, $rcAlerts, $q, $log, $http) {
	    'ngInject';
	
	    // Raw search term the user enters
	
	    _classCallCheck(this, SearchInterfaceController);
	
	    this.searchTerm = "";
	    this.searchTermToSearch = "";
	    this.spellcheck = "";
	    this.initialSearchComplete = false;
	    this.infiniteScrollDisabled = false;
	    this.filter = "";
	
	    this.searchService = new SearchService();
	    this.statsService = new StatsService();
	
	    // Web Search Globals
	    this.webResults = {};
	    this.webResults.loading = false;
	
	    // Feedback
	    this.feedbackModal = {
	      open: false
	    };
	
	    this.$location = $location;
	    this.$rcAlerts = $rcAlerts;
	    this.$q = $q;
	    this.$log = $log;
	    this.$scope = $scope;
	
	    // Check for query parameters
	    this.$onInit = function () {
	      if ($stateParams.q != '' && $stateParams.q !== null && typeof $stateParams.q !== "undefined") {
	        this.searchTerm = $stateParams.q;
	        this.onSearch({ searchTerm: this.searchTerm, filter: this.filter, ignoreSpellcheck: false, spellcheckTerm: null });
	      }
	    };
	  }
	
	  _createClass(SearchInterfaceController, [{
	    key: "onSearch",
	    value: function onSearch(eventObject) {
	      var _this = this;
	
	      this.infiniteScrollDisabled = false;
	      this.searchTerm = eventObject.searchTerm;
	      this.filter = eventObject.filter;
	      var ignoreSpellcheck = eventObject.ignoreSpellcheck;
	
	      this.webResults = {};
	      this.webResults.loading = true;
	
	      this.checkSpelling(this.searchTerm, this.filter).then(function (spellcheck) {
	        _this.spellcheck = spellcheck;
	        _this.searchTermToSearch = _this.searchTerm;
	
	        if (ignoreSpellcheck) {
	          _this.searchTermToSearch = _this.spellcheck.searchTerm;
	        } else if (spellcheck.correctionTerm != "") {
	          _this.searchTermToSearch = _this.spellcheck.correctionTerm;
	        }
	
	        _this.search(_this.searchTermToSearch);
	      });
	    }
	  }, {
	    key: "search",
	    value: function search(searchTermToSearch) {
	      var _this2 = this;
	
	      this.$location.search({ q: searchTermToSearch });
	
	      this.statsService.postQueryStatistic(this.searchTerm, searchTermToSearch).catch(function (message) {
	        _this2.$log.error("Could not post query statistic: " + message);
	      });
	
	      // Request web results
	      this.searchService.getSolrResults(searchTermToSearch, 'web', '*', 10, this.filter, false).then(function (data) {
	        _this2.webResults = data;
	      }).catch(function (message) {
	        _this2.$rcAlerts.error("Please try refreshing the page", "Search Error:", true, true, "UWS", 10000);
	      }).finally(function (done) {
	        _this2.initialSearchComplete = true;
	        _this2.webResults.loading = false;
	      });
	    }
	  }, {
	    key: "checkSpelling",
	    value: function checkSpelling(searchTerm, filter) {
	      var defer = this.$q.defer();
	      var spellcheck = {
	        searchTerm: searchTerm,
	        correctionTerm: ""
	      };
	
	      this.searchService.getSolrResults(searchTerm, 'web', '*', 10, filter).then(function (data) {
	        spellcheck.correctionTerm = data.spellcheck;
	        defer.resolve(spellcheck);
	      });
	
	      return defer.promise;
	    }
	
	    // This is only used for web results
	
	  }, {
	    key: "onLoadMoreResults",
	    value: function onLoadMoreResults() {
	      var _this3 = this;
	
	      if (this.initialSearchComplete === true && this.webResults.loading === false) {
	
	        this.webResults.loading = true;
	        this.searchService.getSolrResults(this.searchTerm, 'web', this.webResults.nextCursorMark, 10, this.filter).then(function (data) {
	          if (_this3.webResults.nextCursorMark === data.nextCursorMark) {
	            _this3.infiniteScrollDisabled = true;
	          }
	
	          _this3.webResults.nextCursorMark = data.nextCursorMark;
	          _this3.webResults.records.push.apply(_this3.webResults.records, data.records);
	          _this3.webResults.loading = false;
	        });
	      }
	    }
	  }, {
	    key: "openFeedback",
	    value: function openFeedback() {
	      this.feedbackModal.open = true;
	    }
	  }, {
	    key: "closeModal",
	    value: function closeModal() {
	      this.feedbackModal.open = false;
	    }
	  }]);
	
	  return SearchInterfaceController;
	}();
	
	exports.default = SearchInterfaceController;
	module.exports = exports['default'];

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _feedbackModal = __webpack_require__(67);
	
	var _feedbackModal2 = _interopRequireDefault(_feedbackModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FeedbackModal = function () {
	    function FeedbackModal() {
	        'ngInject';
	
	        _classCallCheck(this, FeedbackModal);
	
	        angular.extend(this);
	
	        this.isOpen = false;
	        this.loading = false;
	        this.document = {};
	    }
	
	    _createClass(FeedbackModal, [{
	        key: 'closeModal',
	        value: function closeModal() {
	            this.onCancel();
	        }
	    }, {
	        key: 'submitFeedback',
	        value: function submitFeedback() {
	            if (this.feedbackform.$valid) {
	                this.loading = true;
	            }
	
	            /*
	            this.AdminService.updateWebPage('delete', document).then((data) => {
	                this.loading = false;
	                if (data.statusCode === 200) {
	                    this.onComplete({$event: {success: true, message: data.message}});
	                }
	                else {
	                    this.onComplete({$event: {success: false, message: data.message}});
	                }
	            });
	            */
	        }
	    }]);
	
	    return FeedbackModal;
	}();
	
	exports.default = {
	    bindings: {
	        isOpen: '<',
	        onComplete: '&',
	        onCancel: '&'
	    },
	    controller: FeedbackModal,
	    template: _feedbackModal2.default
	};
	module.exports = exports['default'];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _searchBar = __webpack_require__(92);
	
	var _searchBar2 = _interopRequireDefault(_searchBar);
	
	var _webResults = __webpack_require__(93);
	
	var _webResults2 = _interopRequireDefault(_webResults);
	
	var _feedbackModal = __webpack_require__(90);
	
	var _feedbackModal2 = _interopRequireDefault(_feedbackModal);
	
	var _ricola = __webpack_require__(7);
	
	var _ricola2 = _interopRequireDefault(_ricola);
	
	__webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('searchEngineFrontend.searchInterface.shared.components', ['infinite-scroll']).component('searchBar', _searchBar2.default).component('webResults', _webResults2.default).component('feedbackModal', _feedbackModal2.default);
	
	
	angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);
	module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _searchBar = __webpack_require__(68);
	
	var _searchBar2 = _interopRequireDefault(_searchBar);
	
	var _ricola = __webpack_require__(7);
	
	var _ricola2 = _interopRequireDefault(_ricola);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SearchCtrl = function () {
	  function SearchCtrl() {
	    'ngInject';
	
	    _classCallCheck(this, SearchCtrl);
	
	    this.ignoreSpellcheck = false;
	    this.spellcheckTerm = "";
	
	    this.sources = [{
	      label: 'UP',
	      filter: 'up'
	    }, {
	      label: 'Jobs',
	      filter: 'jobs'
	    }];
	
	    this.checkbox = {
	      sources: {
	        up: true,
	        jobs: true
	      }
	    };
	  }
	
	  _createClass(SearchCtrl, [{
	    key: 'search',
	    value: function search(searchTerm, ignoreSpellcheck) {
	      this.searchTerm = searchTerm;
	      this.ignoreSpellcheck = ignoreSpellcheck;
	      this.lastSearchTerm = angular.copy(searchTerm);
	      this.onSearch({
	        $event: {
	          searchTerm: searchTerm,
	          filter: this.createExcludeFilter(this.checkbox.sources),
	          ignoreSpellcheck: ignoreSpellcheck,
	          spellcheckTerm: this.spellcheckTerm
	        }
	      });
	    }
	  }, {
	    key: 'createExcludeFilter',
	    value: function createExcludeFilter(filter) {
	      var filterArray = [];
	      for (var key in filter) {
	        if (!filter[key]) {
	          filterArray.push(key);
	        }
	      }
	      return filterArray.join();
	    }
	  }, {
	    key: 'filterChange',
	    value: function filterChange() {
	      this.search(this.searchTerm, true);
	    }
	  }]);
	
	  return SearchCtrl;
	}();
	
	exports.default = {
	  bindings: {
	    searchTerm: '<',
	    spellcheck: '<',
	    onSearch: '&'
	  },
	  controller: SearchCtrl,
	  template: _searchBar2.default
	};
	module.exports = exports['default'];

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webResults = __webpack_require__(69);
	
	var _webResults2 = _interopRequireDefault(_webResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WebResults = function () {
	    WebResults.$inject = ['StatsService', '$log'];
	    function WebResults(StatsService, $log) {
	        'ngInject';
	
	        _classCallCheck(this, WebResults);
	
	        this.$log = $log;
	        this.statsService = new StatsService();
	        /*
	        this.tags = {
	            'Web': {
	                name: 'Web',
	                regex: /home.www.uprr.com/i
	            },
	            'UPOnline': {
	                name: 'UPOnline',
	                regex: /UPOnline/i
	            },
	            'UP': {
	                name: 'UP',
	                regex: /www.up.com/i
	            },
	            'ITNews': {
	                name: 'ITNews',
	                regex: /ITNews/i
	            }
	        };
	        */
	    }
	
	    _createClass(WebResults, [{
	        key: 'loadMoreResults',
	        value: function loadMoreResults() {
	            this.onLoadMoreResults();
	        }
	    }, {
	        key: 'postActivityStatistic',
	        value: function postActivityStatistic(url, position) {
	            var _this = this;
	
	            this.statsService.postActivityStatistic(this.searchTerm, this.searchTermToSearch, url, position + 1).catch(function (message) {
	                _this.$log.error("Could not post activity statistic: " + message);
	            });
	        }
	
	        /*
	        checkTag(tag, site, newsType) {
	            console.log(site);
	            console.log(tag.regex);
	            console.log(tag.regex.test(site));
	            if (tag.regex.test(site)) {
	                return true;
	            }
	            else if (tag.regex.test(newsType)) {
	                return true;
	            }
	            return false;
	        }
	        */
	
	    }]);
	
	    return WebResults;
	}();
	
	exports.default = {
	    bindings: {
	        results: '<',
	        loading: '<',
	        infiniteScrollDisabled: '<',
	        searchTerm: '<',
	        searchTermToSearch: '<',
	        onLoadMoreResults: '&'
	    },
	    controller: WebResults,
	    template: _webResults2.default
	};
	module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  SERVICE_URL: '/tla/search-engine-frontend/secure/jas',
	  autonomy: '/autonomy-marshaller/jas/results',
	  stats: '/uws/statistics/jas',
	  solr: '/uws/search/service/jas'
	};
	module.exports = exports['default'];

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _components = __webpack_require__(91);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _constants = __webpack_require__(33);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _models = __webpack_require__(99);
	
	var _models2 = _interopRequireDefault(_models);
	
	var _services = __webpack_require__(100);
	
	var _services2 = _interopRequireDefault(_services);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('searchEngineFrontend.searchInterface.shared', [_components2.default.name, _constants2.default.name, _models2.default.name, _services2.default.name]);
	module.exports = exports['default'];

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SendStats = function SendStats($resource, urls) {
	    'ngInject';
	
	    _classCallCheck(this, SendStats);
	
	    return $resource(urls.stats + '/:path', {}, {
	        post: {
	            method: 'POST',
	            timeout: 60000
	        }
	    });
	};
	SendStats.$inject = ['$resource', 'urls'];
	
	exports.default = SendStats;
	module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SolrSearch = function SolrSearch($resource, urls) {
	    'ngInject';
	
	    _classCallCheck(this, SolrSearch);
	
	    return $resource(urls.solr + '/:core', {}, {
	        get: {
	            method: 'GET',
	            timeout: 60000
	        }
	    });
	};
	SolrSearch.$inject = ['$resource', 'urls'];
	
	exports.default = SolrSearch;
	module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SolrSearchSecure = function SolrSearchSecure($resource, urls) {
	    'ngInject';
	
	    _classCallCheck(this, SolrSearchSecure);
	
	    return $resource(urls.solr + '/secure/:core', {}, {
	        get: {
	            method: 'GET',
	            timeout: 60000
	        }
	    });
	};
	SolrSearchSecure.$inject = ['$resource', 'urls'];
	
	exports.default = SolrSearchSecure;
	module.exports = exports['default'];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(33);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _angularResource = __webpack_require__(23);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _SolrSearch = __webpack_require__(97);
	
	var _SolrSearch2 = _interopRequireDefault(_SolrSearch);
	
	var _SolrSearchSecure = __webpack_require__(98);
	
	var _SolrSearchSecure2 = _interopRequireDefault(_SolrSearchSecure);
	
	var _SendStats = __webpack_require__(96);
	
	var _SendStats2 = _interopRequireDefault(_SendStats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('searchEngineFrontend.searchInterface.shared.models', [_angularResource2.default, _constants2.default.name]).service('SolrSearch', _SolrSearch2.default).service('SolrSearchSecure', _SolrSearchSecure2.default).service('SendStats', _SendStats2.default);
	module.exports = exports['default'];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _parserService = __webpack_require__(101);
	
	var _parserService2 = _interopRequireDefault(_parserService);
	
	var _searchService = __webpack_require__(102);
	
	var _searchService2 = _interopRequireDefault(_searchService);
	
	var _statsService = __webpack_require__(103);
	
	var _statsService2 = _interopRequireDefault(_statsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('searchEngineFrontend.searchInterface.shared.services', []).service('ParserService', _parserService2.default).factory('SearchService', _searchService2.default).factory('StatsService', _statsService2.default);
	module.exports = exports['default'];

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = ['$sce', '$log', function ($sce, $log) {
	  'ngInject';
	
	  this.parseSolrData = function (data) {
	    var returnObject = {};
	    returnObject.records = [];
	
	    if (typeof data === 'undefined') {
	      returnObject.showResults = false;
	    } else {
	      returnObject.showResults = true;
	    }
	
	    returnObject.totalRecordsFound = data.totalRecordsFound;
	
	    if (data.core.toUpperCase() == "WEB") {
	      returnObject.spellcheck = data.spellcheck;
	      returnObject.nextCursorMark = data.nextCursorMark;
	      for (var i in data.records) {
	        returnObject.records.push({
	          summary: setSummary(data.records[i]),
	          title: data.records[i].title,
	          reference: setReference(data.records[i].url),
	          url: data.records[i].url,
	          site: data.records[i].site,
	          newsType: data.records[i].newsType,
	          icon: findIcon(data.records[i].url)
	        });
	      }
	    }
	    return returnObject;
	  };
	
	  this.parseOSSData = function (data) {
	    var resultsOutput = [];
	    /*
	    if (parseInstructions === 'hits') {
	        $log.log('received instruction to parse only oss hits');
	        return `(${data.numFound})`;
	    }
	    */
	
	    resultsOutput.showResults = true;
	    for (var i in data.docs) {
	      resultsOutput.push({
	        summary: data.docs[i].txtSummary[0],
	        title: data.docs[i].txtTitle[0],
	        reference: '/knw/selfhelp/chat/secure/index.html#/' + data.docs[i].domainId + '/document/' + data.docs[i].id + '?hf=false&src=upSearch'
	      });
	    }
	    resultsOutput.ossHits = '(' + data.numFound + ')';
	    return resultsOutput;
	  };
	
	  // https://xdev.home.www.uprr.com/uit/ricola/pre3/docs/index.html#/icon
	  function findIcon(url) {
	    if (url.match(/(doc|docx)$/i)) {
	      return "word-doc";
	    } else if (url.match(/pdf$/i)) {
	      return "document-pdf";
	    } else if (url.match(/(ppt|pptx)$/i)) {
	      return "ppt-doc";
	    } else if (url.match(/(xls|xlsx)$/i)) {
	      return "excel-doc";
	    }
	  }
	
	  function setSummary(record) {
	    var summary = "";
	    if (record.description !== null && record.description.replace(/ /g, "") !== "") {
	      summary = record.description;
	    } else if (record.highlight !== null) {
	      summary = record.highlight;
	    } else {
	      summary = record.content;
	    }
	    return summary;
	  }
	
	  function setReference(url) {
	    var reference = "";
	
	    if (url.indexOf("home.www.uprr.com") >= 0 || url.indexOf("employees.www.uprr.com") >= 0) {
	      return url.replace(/^(?:\/\/|[^\/]+)*\//, '/');
	    }
	    return url;
	  }
	}];
	
	module.exports = exports['default'];

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ['$q', 'SolrSearch', 'SolrSearchSecure', 'ParserService', function ($q, SolrSearch, SolrSearchSecure, ParserService) {
	    'ngInject';
	
	    return function () {
	        this.getSolrResults = function (searchTerm, core, cursor, maxResults, filter, secure) {
	            var basicPromise = $q.defer();
	            generateSolrResults(searchTerm, core, cursor, maxResults, filter, secure).then(function (result) {
	                basicPromise.resolve(ParserService.parseSolrData(result));
	            }, function (result) {
	                basicPromise.reject(result);
	            });
	            return basicPromise.promise;
	        };
	
	        function generateSolrResults(searchTerm, core, cursor, maxResults, filter, secure) {
	            if (secure) {
	                return SolrSearchSecure.get({
	                    core: core,
	                    q: searchTerm,
	                    c: cursor,
	                    r: maxResults,
	                    f: filter
	                }).$promise;
	            } else {
	                return SolrSearch.get({
	                    core: core,
	                    q: searchTerm,
	                    c: cursor,
	                    r: maxResults,
	                    f: filter
	                }).$promise;
	            }
	        }
	    };
	}];
	
	module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ['$q', 'SendStats', function ($q, SendStats) {
	    'ngInject';
	
	    return function () {
	        var self = this;
	
	        self.postQueryStatistic = function (searchTerm, correctedSearchTerm) {
	            return SendStats.post({
	                path: 'insert-query-statistic'
	            }, {
	                q: searchTerm,
	                c: correctedSearchTerm
	            }).$promise;
	        };
	
	        self.postActivityStatistic = function (searchTerm, correctedSearchTerm, url, position) {
	            return SendStats.post({
	                path: 'insert-activity-statistic'
	            }, {
	                q: searchTerm,
	                c: correctedSearchTerm,
	                du: url,
	                dr: position
	            }).$promise;
	        };
	    };
	}];
	
	module.exports = exports['default'];

/***/ })
])
});
;


// WEBPACK FOOTER //
// search-engine-frontend-585d5802c4.js